import { render, staticRenderFns } from "./UsuariosSeleccion.vue?vue&type=template&id=0ddbb91b&"
import script from "./UsuariosSeleccion.vue?vue&type=script&lang=js&"
export * from "./UsuariosSeleccion.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosSeleccion.vue?vue&type=style&index=0&id=0ddbb91b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports